<template>
  <div class="account-interaction">
    <div class="account-interaction__header">
      <h1 class="account-interaction__title">{{ $tInteraction('Registration') }}</h1>

      <div v-if="userType === EMPLOYER && data && data.type_of_employment && data.type_of_employment !== 4"
           class="account-interaction__to-custom">
        <div class="account-interaction__to-custom-title  d-none  d-sm-inline">
          {{ $tInteraction('Not suitable processing algorithm?') }}
        </div>
        <div class="account-interaction__to-custom-title  d-sm-none">
          {{ $tInteraction('Not suitable standard processing algorithm?') }}
        </div>
        <button @click.prevent="toCustomInteraction"
                class="account-interaction__to-custom-btn  base-btn  base-btn--small  base-btn--blue">
          <span class="d-none  d-sm-inline">{{ $tInteraction('Individual mode') }}</span>
          <span class="d-sm-none">{{ $tInteraction('Switch to individual mode') }}</span>
        </button>
      </div>

      <div class="account-interaction__info-mob d-none d-md-flex">
        <div class="account-interaction__info-dropdown"
             :class="{'_open': openInfo}"
             v-click-out="closeInfoDropdown">
          <button type="button"
                  class="account-interaction__info-dropdown-trigger base-btn base-btn--outline-grey  base-btn--small"
                  @click.prevent="onOpenInfo"
          >
            <span v-if="!openInfo">{{ $tInteraction('Details') }}</span>
            <span v-else>{{ $tInteraction('Hide') }}</span>
            <BaseSvg name="ico-arrow"/>
          </button>

          <transition name="dropdown">
            <ul v-if="openInfo"
                class="account-interaction__info-dropdown-list">
              <li class="account-interaction__info-dropdown-item">
                <div class="account-interaction__info-dropdown-label">{{ $tInteraction('Vacancy') }}</div>
                <router-link-modified :to="{name: 'vacancy', params: {vacancyId: vacancy[1].slug}}"
                                      target="_blank"
                                      class="account-interaction__info-dropdown-param">
                  {{ vacancyName }}
                </router-link-modified>
              </li>
              <li v-if="userType === EMPLOYER" class="account-interaction__info-dropdown-item">
                <div class="account-interaction__info-dropdown-label">{{ $tInteraction('Candidate') }}</div>
                <router-link-modified :to="{name: 'received-resume', params: {resumeId: resume.send_resume_id}}"
                                      target="_blank"
                                      class="account-interaction__info-dropdown-param">
                  {{ resume.resume_data[1].surname }} {{ resume.resume_data[1].name }}
                </router-link-modified>
              </li>
              <li v-if="userType === EMPLOYEE" class="account-interaction__info-dropdown-item">
                <div class="account-interaction__info-dropdown-label">{{ $tInteraction('The contact person') }}</div>
                <router-link-modified
                  v-if="vacancy.employer.employerProfile"
                  target="_blank"
                  :to="{name: 'company-info', params: {companySlug: vacancy.employer.employerProfile.slug}}"
                  class="account-interaction__info-dropdown-param">
                  {{ vacancy.employer.fullname }}
                </router-link-modified>
                <span v-else class="account-interaction__info-dropdown-param">Jobian</span>
              </li>
            </ul>
          </transition>
        </div>
        <button v-if="userType === EMPLOYER"
                type="button"
                @click="onReject"
                class="account-interaction__info-mob-cancel base-btn base-btn--outline-orange base-btn--small">
          <BaseSvg name="ico-close"
                   width="1.1rem"
                   height="1.1rem"/>
          <span>{{ $tInteraction('Deny') }}</span>
        </button>
      </div>
    </div>

    <div class="account-interaction__panel-info interaction-panel-info d-md-none" v-if="!pending">
      <div class="interaction-panel-info__item">
        <h3 class="interaction-panel-info__item-title">{{ $tInteraction('Vacancy') }}</h3>
        <!--img-->
        <v-lazy-image v-if="vacancy[3] && vacancy[3].images.length"
                      use-picture
                      :src="vacancy[3].images[0].path"
                      :srcset="vacancy[3].images[0].path_webp"
                      :title="vacancy[1].name"
                      :alt="vacancy[1].name"
                      class="interaction-panel-info__item-img"
        >
          <source
            type="image/webp"
            :srcset="vacancy[3].images[0].path_webp"
          >
        </v-lazy-image>
        <picture v-else
                 class="interaction-panel-info__item-img _no-photo">
          <img src="@/assets/img/png/no-photo-placeholder.png"
               :title="vacancy[1].name"
               :alt="vacancy[1].name">
        </picture>
        <!---->
        <div class="interaction-panel-info__item-main">
          <div class="interaction-panel-info__item-name">{{ vacancyName }}</div>
          <router-link-modified :to="{name: 'vacancy', params: {vacancyId: vacancy[1].slug}}"
                                target="_blank"
                                class="interaction-panel-info__item-link">
            {{ $tInteraction('Full information') }}
          </router-link-modified>
        </div>
      </div>

      <div class="interaction-panel-info__item _user" v-if="userType === EMPLOYER">
        <h3 class="interaction-panel-info__item-title">{{ $tInteraction('Candidate') }}</h3>
        <!--img-->
        <v-lazy-image v-if="resume.resume_data[3].photos.length"
                      use-picture
                      :src="resume.resume_data[3].photos[0].path"
                      :srcset="resume.resume_data[3].photos[0].path_webp"
                      :title="`${resume.resume_data[1].surname} ${resume.resume_data[1].name}`"
                      :alt="`${resume.resume_data[1].surname} ${resume.resume_data[1].name}`"
                      class="interaction-panel-info__item-img"
        >
          <source
            type="image/webp"
            :srcset="resume.resume_data[3].photos[0].path_webp"
          >
        </v-lazy-image>
        <!--        <picture v-else-->
        <!--                 class="interaction-panel-info__item-img _no-photo">-->
        <!--          <img src="../../assets/img/svg/avatar-clear.svg"-->
        <!--               :title="`${resume.resume_data[1].surname} ${resume.resume_data[1].name}`"-->
        <!--               :alt="`${resume.resume_data[1].surname} ${resume.resume_data[1].name}`">-->
        <!--        </picture>-->
        <div v-else class="interaction-panel-info__item-img">
          <div class="interaction-panel-info__item-img-placeholder">
            {{ getPhotoTextPlaceholder(resume.resume_data[1].name, resume.resume_data[1].surname) }}
          </div>
        </div>
        <!---->
        <div class="interaction-panel-info__item-main">
          <div class="interaction-panel-info__item-name">{{ resume.resume_data[1].surname }}
            {{ resume.resume_data[1].name }}
          </div>
          <router-link-modified :to="{name: 'received-resume', params: {resumeId: resume.send_resume_id}}"
                                target="_blank"
                                class="interaction-panel-info__item-link">
            {{ $tInteraction('Resume') }}
          </router-link-modified>
        </div>
        <button type="button"
                @click.prevent="onReject"
                class="interaction-panel-info__deny-btn base-btn base-btn--outline-orange">
          <BaseSvg name="ico-close"
                   width="1.4rem"
                   height="1.4rem"/>
          <span>{{ $tInteraction('Deny') }}</span>
        </button>
      </div>

      <div v-else-if="vacancy.employer.employerProfile" class="interaction-panel-info__item _user">
        <h3 class="interaction-panel-info__item-title">{{ $tInteraction('The contact person') }}</h3>
        <!--img-->
        <v-lazy-image v-if="vacancy.employer.avatar"
                      use-picture
                      :src="vacancy.employer.avatar"
                      :title="vacancy.employer.fullname"
                      :alt="vacancy.employer.fullname"
                      class="interaction-panel-info__item-img"
        >
          <source
            type="image/webp"
            :srcset="vacancy.employer.employerProfile.company_logo_webp"
          >
        </v-lazy-image>
        <picture v-else
                 class="interaction-panel-info__item-img _no-photo">
          <img src="../../assets/img/svg/avatar-clear.svg"
               :title="vacancy.employer.fullname"
               :alt="vacancy.employer.fullname">
        </picture>
        <!---->
        <div class="interaction-panel-info__item-main">
          <div class="interaction-panel-info__item-name">{{ vacancy.employer.fullname }}</div>
          <router-link-modified
            :to="{name: 'company-info', params: {companySlug: vacancy.employer.employerProfile.slug}}"
            target="_blank"
            class="interaction-panel-info__item-link">
            {{ $tInteraction('Full information') }}
          </router-link-modified>
        </div>
      </div>

      <div v-else class="interaction-panel-info__item _user">
        <h3 class="interaction-panel-info__item-title">{{ $tInteraction('The contact person') }}</h3>
        <picture class="interaction-panel-info__item-img _no-photo">
          <img :src="globalConfigs.header.logo_vertical"
               title="Jobian"
               alt="Jobian">
        </picture>
        <div class="interaction-panel-info__item-main">
          <div class="interaction-panel-info__item-name">Jobian</div>
        </div>
      </div>

    </div>

    <div class="account-interaction__content" id="interaction-content">
      <InteractionNavBar class="account-interaction__nav"/>

      <!--demo steps-->
      <div v-if="false" class="account-interaction__inner">
        <div class="account-interaction__inner-scroll custom-scrollbar">
          <InteractionStepCheckReceipt v-if="false"/>
          <InteractionStepSentWaiting v-if="false"/>
          <InteractionStepWelcome v-if="false"/>
        </div>
      </div>
      <!---->

      <div v-else class="account-interaction__inner">
        <div v-if="pending"
             class="account-interaction__inner-scroll custom-scrollbar">
          <BasePreloader/>
        </div>

        <div v-else
             :key="step"
             class="account-interaction__inner-scroll custom-scrollbar">

          <InteractionStepCustom v-if="isCustomStepPlaceholder"/>
          <InteractionWaitingArrival v-else-if="waiting && step === STEP_CONFIRM_ARRIVAL"/>
          <InteractionWaiting v-else-if="waiting"/>

          <InteractionStepType v-else-if="step === STEP_EMPLOYMENT_TYPE"/>
          <InteractionStepBuyInsurance v-else-if="step === STEP_BUYING_INSURANCE"/>
          <InteractionStepCheckInsurance v-else-if="step === STEP_CHECK_INSURANCE"/>
          <InteractionStepDataUser v-else-if="step === STEP_STATEMENT_FORM"/>
          <InteractionStepDataUser2 v-else-if="step === STEP_VISA_CREATION_FORM"/>
          <InteractionStepEmploymentOfferAccept v-else-if="step === STEP_EMPLOYMENT_OFFER_ACCEPT"/>
          <InteractionStepBuyTicket v-else-if="step === STEP_BUY_TICKETS"/>
          <InteractionStepPayServiceFee v-else-if="step === STEP_PAY_SERVICE_FEE"/>
          <InteractionStepCheckTickets v-else-if="step === STEP_CHECK_TICKETS"/>
          <InteractionStepConfirmArrival v-else-if="step === STEP_CONFIRM_ARRIVAL"/>
          <InteractionStepContract v-else-if="step === STEP_CONTRACT"/>
          <InteractionStepArrivalInfo v-else-if="step === STEP_ARRIVAL"/>
          <InteractionStepSendReview v-else-if="step === STEP_SEND_REVIEW"/>
          <InteractionStepSelectVisaOptions v-else-if="step === STEP_SELECT_VISA_OPTIONS"/>
          <InteractionStepVisaCenterVisitDate v-else-if="step === STEP_VISA_CENTER_VISIT_DATA"/>
          <InteractionStepUploadVisa v-else-if="step === STEP_UPLOAD_VISA"/>
          <InteractionStepCheckVisa v-else-if="step === STEP_CHECK_VISA"/>
          <InteractionStepWithTransfer v-else-if="step === STEP_WITH_TRANSFER"/>
          <InteractionStepArrivalInfoShow v-else-if="step === STEP_ARRIVAL_INFO_SHOW"/>
          <InteractionStepVisaInfoShow v-else-if="step === STEP_VISA_INFO_SHOW"/>
          <InteractionStepVisaInfoShowBiometrics v-else-if="step === STEP_VISA_INFO_SHOW_BIOMETRIC"/>
          <InteractionStepRequirements v-else-if="step === STEP_REQUIREMENTS"/>
          <InteractionStepRequirementsAnswer v-else-if="step === STEP_REQUIREMENTS_ANSWER"/>
          <InteractionStepRequirementsCheck v-else-if="step === STEP_REQUIREMENTS_CHECK"/>
          <InteractionStepUploadInvitation v-else-if="step === STEP_UPLOAD_INVITATION"/>
          <InteractionStepWelcome visa v-else-if="step === STEP_WELCOME_VISA"/>
          <InteractionStepWelcome biometric v-else-if="step === STEP_WELCOME_BIOMETRIC"/>
          <InteractionStepCheckReceipt v-else-if="step === STEP_RECEIPT_CHECK"/>
          <InteractionStepSentWaiting v-else-if="step === STEP_DOCUMENTS_SENT_WAITING"/>

          <InteractionAcceptReceivedFiles v-else-if="step === STEP_CUSTOM_INSURANCE"
                                          :checkText="$tInteraction('The insurance has been downloaded and verified.')"/>
          <InteractionAcceptReceivedFiles v-else-if="step === STEP_CUSTOM_VISA"
                                          :checkText="$tInteraction('The visa has been loaded and verified.')"/>
          <InteractionAcceptReceivedFiles v-else-if="step === STEP_CUSTOM_TICKETS"
                                          :checkText="$tInteraction('Tickets loaded and verified.')"/>
          <InteractionAcceptReceivedFiles v-else-if="step === STEP_CUSTOM_CONTRACT"
                                          :checkText="$tInteraction('The employment contract has been uploaded and verified.')"/>

          <InteractionStepEmployerEnd v-else-if="step === STEP_END && userType === EMPLOYER"/>
          <InteractionStepEmployeeEnd v-else-if="step === STEP_END && userType === EMPLOYEE"/>


          <InteractionStepWelcome v-else-if="step === STEP_CUSTOM_WELCOME"/>
          <InteractionStepViseSendingType v-else-if="step === STEP_VISA_SENDING_TYPE"/>

          <div v-else style="margin: auto">
            {{ $tInteraction('No step') }}

          </div>
        </div>
      </div>
      <div class="account-interaction__side">
        <div v-if="windowSizeMixin.width > 1023"
             class="account-interaction__side-tabs">
          <button @click.prevent="onOpenTab('showChat')"
                  :class="showChat ? '_active' : null"
                  class="account-interaction__side-tab">
            {{
              userType === EMPLOYER
                ? $tInteraction('Chat with employee')
                : $tInteraction('Chat with employer')
            }}
          </button>
          <button @click.prevent="onOpenTab('showFiles')"
                  :class="showFiles ? '_active' : null"
                  class="account-interaction__side-tab">
            {{ $tInteraction('File sharing') }}
            <span v-if="hasNewFromServerFiles"
                  class="account-interaction__side-tab-mark-status"></span>
          </button>
        </div>
        <transition name="fade"
                    :mode="windowSizeMixin.width > 1023 ? 'out-in' : null">
          <InteractionChat v-if="windowSizeMixin.width > 1023 && showChat || showChatMobile"
                           key="showChat"
                           class="account-interaction__chat"
                           @open-tab="onOpenTabMob"
                           @close="onCloseTab('showChatMobile')"
                           :class="{'_active': showChat}"/>
          <InteractionFiles v-if="windowSizeMixin.width > 1023 && showFiles || showFilesMobile"
                            key="showFiles"
                            class="account-interaction__files"
                            @open-tab="onOpenTabMob"
                            @close="onCloseTab('showFilesMobile')"
                            :class="{'_active': showFiles}"/>
        </transition>
      </div>
      <div class="interaction-toggle  d-none  d-md-flex  _reverse">
        <button type="button"
                class="interaction-toggle__btn  _active">
          <BaseSvg name="ico-gear-2"
                   width="1.5rem"
                   height="1.5rem"/>
          <span>{{ $tInteraction('Actions') }}</span>
        </button>
        <button type="button"
                class="interaction-toggle__btn "
                @click.prevent="onOpenTabMob('showChatMobile')">
          <BaseSvg name="ico-msg"
                   width="1.7rem"
                   height="1.5rem"/>
          <span>{{ $tInteraction('Chat') }}</span>
        </button>
        <button type="button"
                class="interaction-toggle__btn"
                :class="hasNewFromServerFiles ? '_accent' :  null"
                @click.prevent="onOpenTabMob('showFilesMobile')">
          <BaseSvg name="ico-msg"
                   width="1.7rem"
                   height="1.5rem"/>
          <span>{{ $tInteraction('Files') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from 'vuex'
  import {
    STEP_EMPLOYMENT_TYPE,
    STEP_BUYING_INSURANCE,
    STEP_CHECK_INSURANCE,
    STEP_ARRIVAL,
    STEP_STATEMENT_FORM,
    STEP_VISA_CREATION_FORM,
    STEP_BUY_TICKETS,
    STEP_CHECK_TICKETS,
    STEP_CONFIRM_ARRIVAL,
    STEP_PAY_SERVICE_FEE,
    STEP_SELECT_VISA_OPTIONS,
    STEP_VISA_CENTER_VISIT_DATA,
    STEP_UPLOAD_VISA,
    STEP_CHECK_VISA,
    STEP_WITH_TRANSFER,
    STEP_EMPLOYMENT_OFFER_ACCEPT,
    STEP_SEND_REVIEW,
    STEP_CONTRACT,
    STEP_ARRIVAL_INFO_SHOW,
    STEP_VISA_INFO_SHOW,
    STEP_VISA_INFO_SHOW_BIOMETRIC,
    STEP_REQUIREMENTS,
    STEP_REQUIREMENTS_ANSWER,
    STEP_REQUIREMENTS_CHECK,
    STEP_UPLOAD_INVITATION,
    STEP_END,
    STEP_WELCOME_VISA,
    STEP_WELCOME_BIOMETRIC,
    STEP_RECEIPT_CHECK,
    STEP_DOCUMENTS_SENT_WAITING,
    STEP_CUSTOM_WELCOME,
    STEP_CUSTOM_INSURANCE,
    STEP_CUSTOM_VISA,
    STEP_CUSTOM_TICKETS,
    STEP_CUSTOM_CONTRACT,
    STEP_VISA_SENDING_TYPE,
  } from '@/constants/interaction'
  import {EMPLOYER, EMPLOYEE} from '@/constants/usersTypes'

  import InteractionWaiting from '../../components/interactions/InteractionWaiting'
  import InteractionStepType from '../../components/interactions/steps/InteractionStepType'
  import InteractionStepContract from '../../components/interactions/steps/InteractionStepContract'
  import InteractionStepDataUser from '../../components/interactions/steps/InteractionStepDataUser'
  import InteractionStepDataUser2 from '../../components/interactions/steps/InteractionStepDataUser2'
  import windowSizeMixin from '../../mixins/windowSizeMixin'
  import {blockScroll, unBlockScroll} from '../../helpers/scroll'
  import {eventBus} from '../../main'
  import InteractionNavBar from '../../components/interactions/InteractionNavBar'
  import InteractionChat from '../../components/interactions/InteractionChat'
  import InteractionFiles from '../../components/interactions/InteractionFiles'
  import InteractionStepSendReview from '../../components/interactions/steps/InteractionStepSendReview'

  //EMPLOYEE
  import InteractionStepCustom from '../../components/interactions/stepsEmployee/InteractionStepCustom'
  import InteractionStepBuyInsurance from '../../components/interactions/stepsEmployee/InteractionStepBuyInsurance'
  import InteractionStepBuyTicket from '../../components/interactions/stepsEmployee/InteractionStepBuyTicket'
  import InteractionStepPayServiceFee from '../../components/interactions/stepsEmployee/InteractionStepPayServiceFee'
  import InteractionStepEmployeeEnd from '../../components/interactions/stepsEmployee/InteractionStepEmployeeEnd'
  import InteractionStepSelectVisaOptions
    from '../../components/interactions/stepsEmployee/InteractionStepSelectVisaOptions'
  import InteractionStepVisaCenterVisitDate
    from '../../components/interactions/stepsEmployee/InteractionStepVisaCenterVisitDate'
  import InteractionStepUploadVisa from '../../components/interactions/stepsEmployee/InteractionStepUploadVisa'
  import InteractionStepArrivalInfoShow
    from '../../components/interactions/stepsEmployee/InteractionStepArrivalInfoShow'
  import InteractionStepRequirementsAnswer
    from '../../components/interactions/stepsEmployee/InteractionStepRequirementsAnswer'
  import InteractionWaitingArrival from '../../components/interactions/stepsEmployee/InteractionWaitingArrival'
  import InteractionStepViseSendingType
    from '../../components/interactions/stepsEmployee/InteractionStepViseSendingType'

  //EMPLOYER
  import InteractionStepCheckInsurance from '../../components/interactions/stepsEmployer/InteractionStepCheckInsurance'
  import InteractionStepEmploymentOfferAccept
    from '../../components/interactions/stepsEmployer/InteractionStepEmploymentOfferAccept'
  import InteractionStepArrivalInfo from '../../components/interactions/stepsEmployer/InteractionStepArrivalInfo'
  import InteractionStepCheckTickets from '../../components/interactions/stepsEmployer/InteractionStepCheckTickets'
  import InteractionStepConfirmArrival from '../../components/interactions/stepsEmployer/InteractionStepConfirmArrival'
  import InteractionStepEmployerEnd from '../../components/interactions/stepsEmployer/InteractionStepEmployerEnd'
  import InteractionStepCheckVisa from '../../components/interactions/stepsEmployer/InteractionStepCheckVisa'
  import InteractionStepWithTransfer from '../../components/interactions/stepsEmployer/InteractionStepWithTransfer'
  import InteractionStepVisaInfoShow from '../../components/interactions/stepsEmployer/InteractionStepVisaInfoShow'
  import InteractionStepVisaInfoShowBiometrics
    from '../../components/interactions/stepsEmployer/InteractionStepVisaInfoShowBiometrics'
  import InteractionStepRequirements from '../../components/interactions/stepsEmployer/InteractionStepRequirements'
  import InteractionStepRequirementsCheck
    from '../../components/interactions/stepsEmployer/InteractionStepRequirementsCheck'
  import InteractionStepUploadInvitation
    from '../../components/interactions/stepsEmployer/InteractionStepUploadInvitation'
  import InteractionAcceptReceivedFiles
    from '../../components/interactions/stepsEmployer/InteractionAcceptReceivedFiles'

  //demo
  import InteractionStepCheckReceipt from '@/components/interactions/demoSteps/InteractionStepCheckReceipt'
  import InteractionStepSentWaiting from '@/components/interactions/demoSteps/InteractionStepSentWaiting'
  import InteractionStepWelcome from '@/components/interactions/demoSteps/InteractionStepWelcome'


  export default {
    name: 'AccountInteractionPage',
    components: {
      InteractionStepWelcome,
      InteractionStepSentWaiting,
      InteractionStepCheckReceipt,
      // OverlayScrollbarsComponentCustomize,
      InteractionWaiting,
      InteractionChat,
      InteractionFiles,
      InteractionNavBar,
      InteractionStepContract,
      InteractionStepBuyInsurance,
      InteractionStepType,
      InteractionStepDataUser,
      InteractionStepDataUser2,
      InteractionStepSendReview,
      InteractionStepCustom,

      InteractionStepCheckInsurance,
      InteractionStepBuyTicket,
      InteractionStepPayServiceFee,
      InteractionStepEmploymentOfferAccept,
      InteractionStepArrivalInfo,
      InteractionStepCheckTickets,
      InteractionStepConfirmArrival,
      InteractionStepEmployeeEnd,
      InteractionStepEmployerEnd,
      InteractionStepSelectVisaOptions,
      InteractionStepVisaCenterVisitDate,
      InteractionStepUploadVisa,
      InteractionStepCheckVisa,
      InteractionStepWithTransfer,
      InteractionStepArrivalInfoShow,
      InteractionStepVisaInfoShow,
      InteractionStepVisaInfoShowBiometrics,
      InteractionStepRequirements,
      InteractionStepRequirementsAnswer,
      InteractionStepRequirementsCheck,
      InteractionStepUploadInvitation,
      InteractionWaitingArrival,
      InteractionAcceptReceivedFiles,
      InteractionStepViseSendingType,
    },
    mixins: [windowSizeMixin],
    data() {
      return {
        openInfo: false,
        counter: 1,
        scrollOptions: {
          overflowBehavior: {
            x: 'hidden',
            y: 'scroll'
          }
        },
        showChat: true,
        showFiles: false,
        showChatMobile: false,
        showFilesMobile: false,
        timer: null,
        STEP_EMPLOYMENT_TYPE,
        STEP_STATEMENT_FORM,
        STEP_CHECK_INSURANCE,
        STEP_ARRIVAL,
        STEP_VISA_CREATION_FORM,
        STEP_BUY_TICKETS,
        STEP_CHECK_TICKETS,
        STEP_CONFIRM_ARRIVAL,
        STEP_PAY_SERVICE_FEE,
        STEP_SELECT_VISA_OPTIONS,
        STEP_VISA_CENTER_VISIT_DATA,
        STEP_UPLOAD_VISA,
        STEP_CHECK_VISA,
        STEP_WITH_TRANSFER,
        STEP_BUYING_INSURANCE,
        STEP_EMPLOYMENT_OFFER_ACCEPT,
        STEP_SEND_REVIEW,
        STEP_CONTRACT,
        STEP_END,
        STEP_ARRIVAL_INFO_SHOW,
        STEP_VISA_INFO_SHOW,
        STEP_VISA_INFO_SHOW_BIOMETRIC,
        STEP_REQUIREMENTS,
        STEP_REQUIREMENTS_ANSWER,
        STEP_REQUIREMENTS_CHECK,
        STEP_UPLOAD_INVITATION,
        STEP_WELCOME_VISA,
        STEP_WELCOME_BIOMETRIC,
        STEP_RECEIPT_CHECK,
        STEP_DOCUMENTS_SENT_WAITING,
        STEP_CUSTOM_WELCOME,
        STEP_CUSTOM_INSURANCE,
        STEP_CUSTOM_VISA,
        STEP_CUSTOM_TICKETS,
        STEP_CUSTOM_CONTRACT,
        STEP_VISA_SENDING_TYPE,

        EMPLOYER,
        EMPLOYEE,
        globalConfigs
      }
    },
    computed: {
      ...mapState('interaction', [
        'pending',
        'waiting',
        'step',
        'resume',
        'vacancy',
        'data',
        'stepData',
      ]),
      ...mapState('interaction/files', {
        'hasNewFromServerFiles': 'hasNewFromServer'
      }),
      // pending() {
      //   return false
      // },
      // waiting() {
      //   return false
      // },
      // step() {
      //   return STEP_ARRIVAL
      // },
      userType() {
        return this.$store.state.user.profile.user_type
      },
      currentLocale() {
        return this.$store.state.currentLocale
      },
      vacancyName() {
        return this.vacancy[1].name
        // const nameObj = this.vacancy[1].name && JSON.parse(this.vacancy[1].name)
        // return nameObj[this.currentLocale]
      },
      isCustomStepPlaceholder() {
        // debugger
        // console.log('data', this.data)
        // console.log('stepData', this.stepData)
        return this.data.type_of_employment === 4 && this.waiting && this.userType === EMPLOYEE
      }
    },
    methods: {
      ...mapMutations('interaction', [
        'resetState',
      ]),
      ...mapActions('interaction', [
        'loadData',
        'stopWatchNextStep',
        'showHintDefaultSetInitial',
        'subscriberOnUpdate',
      ]),
      ...mapActions('interaction/files', {
        'stopFiles': 'stop',
        'subscriberOnUpdateFiles': 'subscriberOnUpdate',
        'getViewedStatusFiles': 'getViewedStatus',
      }),
      onNext() {
        if (this.counter < 8) {
          ++this.counter
        } else {
          this.counter = 1
        }
      },
      onOpenInfo() {
        this.openInfo = !this.openInfo
      },
      closeInfoDropdown() {
        this.openInfo = false
      },
      onOpenTab(key) {
        this.showChat = false
        this.showFiles = false

        this[key] = true
      },
      onOpenTabMob(key) {
        this.showChatMobile = false
        this.showFilesMobile = false

        if (this.windowSizeMixin.width < 1024) {
          blockScroll()
        }

        this[key] = true
      },
      onCloseTab(key) {
        unBlockScroll()
        this[key] = false
      },
      onReject() {
        this.$vModal.open('reject-candidate', {
          resumeId: +this.$route.params.id,
          isInteraction: true
        })

        // const title = this.userType === EMPLOYEE ? this.$tInteraction('Reject the vacancy?') : this.$tInteraction('Reject resume?')
        // this.$vModal.open('confirm', {
        //   title,
        //   onSuccess: () => {
        //     http.delete(`api/new-interaction/decline/${this.$route.params.id}`).then(() => {
        //       if (this.userType === EMPLOYER) {
        //         this.$router.push({name: 'account-received-resume'})
        //       } else {
        //         this.$router.push({name: 'account-resumes'})
        //       }
        //
        //       this.$vModal.close('confirm')
        //     })
        //   }
        // })
      },
      getPhotoTextPlaceholder(name, surname) {
        name = name || ''
        surname = surname || ''
        return (surname.slice(0, 1) + name.slice(0, 1)).toUpperCase()
      },
      toCustomInteraction() {
        this.$vModal.open('to-custom-interaction', {
          iterationId: +this.$route.params.id
        })
      }
    },
    created() {
      this.resetState()
      this.loadData(this.$route.params.id)
      eventBus.$on('onNextEvent', () => {
        this.$store.commit('interaction1/pending', true)
        this.onNext()
        setTimeout(() => {
          this.$store.commit('interaction1/pending', false)
        }, 1500)
      })

      this.showHintDefaultSetInitial()
    },
    mounted() {
      if (this.$route.query.openChat === true) {
        this.onOpenTab('showChat')
      }

      this.getViewedStatusFiles()
      this.subscriberOnUpdate()
      this.subscriberOnUpdateFiles()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkMob)
      this.stopWatchNextStep()
      this.stopFiles()
    },
  }
</script>

<style>

</style>
